import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';
import { Input, InputField } from '@components/form';

const View: React.SFC<any> = () => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col className="grid-system-margin" />
      </Row>
      <Row>
        <Col md={12}>
          {[
            { name: 'name', label: 'Název', disabled: true },
            { name: 'category.name', label: 'Kategorie', disabled: true },
            { name: 'employee.fullName', label: 'Strážník', disabled: true },
            { name: 'note', label: 'Poznámka' }
          ].map(field => (
            <Col xs={12} key={field.name}>
              <InputField component={Input} {...field} />
            </Col>
          ))}
        </Col>
      </Row>
    </Grid>

    <Divider />
  </div>
);
export const MyItemsFormBasic = View;



// WEBPACK FOOTER //
// ./src/modules/myItems/myItemsFormBasic.tsx